import React, { createContext, useContext, useEffect, useState } from "react";
import { api } from "@/lib/api";

const AuthCtx = createContext(null);
export const useAuth = () => useContext(AuthCtx);

export const AuthProvider = ({ children }) => {
    const [user, setUser] = useState(null);
    const [token, setToken] = useState(() => localStorage.getItem("hfx_token"));
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        let cancelled = false;
        const load = async () => {
            if (!token) { setLoading(false); setUser(null); return; }
            setLoading(true);
            try {
                const res = await api.get("/auth/me");
                if (!cancelled) setUser(res.data);
            } catch {
                if (!cancelled) { setUser(null); setToken(null); localStorage.removeItem("hfx_token"); }
            } finally {
                if (!cancelled) setLoading(false);
            }
        };
        load();
        return () => { cancelled = true; };
    }, [token]);

    const signIn = async (email, password) => {
        const res = await api.post("/auth/login", { email, password });
        localStorage.setItem("hfx_token", res.data.access_token);
        setToken(res.data.access_token);
        return res.data;
    };

    const register = async (payload) => {
        const res = await api.post("/auth/register", payload);
        localStorage.setItem("hfx_token", res.data.access_token);
        setToken(res.data.access_token);
        return res.data;
    };

    const signOut = () => {
        localStorage.removeItem("hfx_token");
        setToken(null);
        setUser(null);
    };

    /**
     * Re-fetch /auth/me. Used after email verification, profile edits, etc.
     */
    const refreshUser = async () => {
        if (!token) return;
        try {
            const res = await api.get("/auth/me");
            setUser(res.data);
        } catch (err) {
            console.warn("refreshUser failed", err);
        }
    };

    return (
        <AuthCtx.Provider value={{ user, token, loading, signIn, register, signOut, refreshUser }}>
            {children}
        </AuthCtx.Provider>
    );
};
